export type SignalSelectionTooltipLabels = {
    readonly signalType?: readonly string[];
    readonly signalData?: readonly string[];
};

export function getSignalTypeTooltipLabels(
    labels?: Readonly<SignalSelectionTooltipLabels>,
): readonly string[] | undefined {
    return labels?.signalType;
}

export function getSignalDataTooltipLabels(
    labels?: Readonly<SignalSelectionTooltipLabels>,
): readonly string[] | undefined {
    return labels?.signalData;
}
